/**
 * ENUM values shared between frontend and backend.
 * These must match the database ENUM definitions in schema.sql.
 */

export const CONTENT_CATEGORIES = [
  'Onboarding',
  'Technical',
  'Safety',
  'Certification',
  'Marine'
];

export const MODULE_CATEGORIES = [
  'Onboarding',
  'Technical',
  'Safety',
  'Certification',
  'Marine'
];

export const VR_PLATFORMS = [
  'Web Browser',
  'Meta Quest 3',
  'Apple Vision Pro',
  'Pico 4',
  'iOS',
  'Android'
];

export const CONTENT_TYPES = {
  VR_APP: 'vr_app',
  WEB_VIRTUAL_TOUR: 'web_virtual_tour'
};

export const STATUS_VALUES = {
  ACTIVE: 'Active',
  DRAFT: 'Draft'
};

export const USER_ROLES = {
  ADMINISTRATOR: 'Administrator',
  INSTRUCTOR: 'Instructor',
  TRAINEE: 'Trainee'
};

export const MODULE_LEVELS = [
  'Beginner',
  'Intermediate',
  'Advanced'
];